import { type RouteObject } from "react-router-dom";

import { AUTH_ROLES } from "api/common/types/auth.types";
import NistDetails from "components/NIST/NISTDetails";
import NISTTable from "components/NIST/NISTTable";
import AuthenticatedRoute from "routing/AuthenticatedRoute";

const { VALIDATOR, NIAP, LAB } = AUTH_ROLES;

const nistRoutes: RouteObject[] = [
  {
    path: "nist",
    element: <AuthenticatedRoute allowedRoles={[NIAP, LAB, VALIDATOR]} />,

    children: [
      { index: true, element: <NISTTable /> },
      { path: "details/:nist_id", element: <NistDetails /> },
    ],
  },
];

export default nistRoutes;
